import {CommonModule} from "@angular/common";
import {AngularSplitModule} from "angular-split";
import {NgModule} from "@angular/core";
import {DxPageComponent} from "./ui/components/page/dx-page.component";
import {DxPageHeaderComponent} from "./ui/components/page-header/dx-page-header.component";
import {DxErrorReportComponent} from "./ui/components/error-report/dx-error-report.component";
import {DxErrorPageComponent} from "./ui/components/error-page/dx-error-page.component";
import {DxPageHeaderDirective} from "./ui/directives/page/dx-page-header.directive";
import {DxPageSideDirective} from "./ui/directives/page/dx-page-side.directive";
import {DxPageContentDirective} from "./ui/directives/page/dx-page-content.directive";
import {DxPageFooterDirective} from "./ui/directives/page/dx-page-footer.directive";
import {DxPageHeaderAppLogoDirective} from "./ui/directives/page-header/dx-page-header-app-logo.directive";
import {DxPageHeaderAppTitleDirective} from "./ui/directives/page-header/dx-page-header-app-title.directive";
import {DxPageHeaderComboDirective} from "./ui/directives/page-header/dx-page-header-combo.directive";
import {DxPageHeaderLogoutBarDirective} from "./ui/directives/page-header/dx-page-header-logout-bar.directive";
import {DxPageHeaderNavBarDirective} from "./ui/directives/page-header/dx-page-header-nav-bar.directive";
import {DxPageHeaderSettingsBarDirective} from "./ui/directives/page-header/dx-page-header-settings-bar.directive";
import {DxPageHeaderToolBtnDirective} from "./ui/directives/page-header/dx-page-header-tool-btn.directive";
import {DxPageHeaderUserBarDirective} from "./ui/directives/page-header/dx-page-header-user-bar.directive";
import {DxPageHeaderHelpBarDirective} from "./ui/directives/page-header/dx-page-header-help-bar.directive";
import {DxPageHeaderNotificationBarDirective} from "./ui/directives/page-header/dx-page-header-notification-bar.directive";
import {DxErrorPageHeaderDirective} from "./ui/directives/error-page/dx-error-page-header.directive";
import {DxSplittedAreaComponent} from "./ui/components/splittable-area/dx-splitted-area.component";
import {DxSplittedAreaItemDirective} from "./ui/directives/splittable-area/dx-splitted-area-item.directive";


/**
 *  Экспортирует базовую разметку страницы приложения: шаблонизированные UI-комопоненты для: базовой разметки страницы,
 *  заголовка страницы, отчета об ошибке в работе приложения
 *  @publicApi
 */
@NgModule({
  declarations: [
    DxPageComponent,
    DxPageHeaderComponent,
    DxErrorReportComponent,
    DxErrorPageComponent,
    DxPageHeaderDirective,
    DxPageSideDirective,
    DxPageContentDirective,
    DxPageFooterDirective,
    DxPageHeaderAppLogoDirective,
    DxPageHeaderAppTitleDirective,
    DxPageHeaderComboDirective,
    DxPageHeaderLogoutBarDirective,
    DxPageHeaderNavBarDirective,
    DxPageHeaderToolBtnDirective,
    DxPageHeaderUserBarDirective,
    DxPageHeaderHelpBarDirective,
    DxPageHeaderSettingsBarDirective,
    DxPageHeaderNotificationBarDirective,
    DxErrorPageHeaderDirective,
    DxSplittedAreaComponent,
    DxSplittedAreaItemDirective
  ],
  exports: [
    DxPageComponent,
    DxPageHeaderComponent,
    DxErrorReportComponent,
    DxErrorPageComponent,
    DxPageHeaderDirective,
    DxPageSideDirective,
    DxPageContentDirective,
    DxPageFooterDirective,
    DxPageHeaderAppLogoDirective,
    DxPageHeaderAppTitleDirective,
    DxPageHeaderComboDirective,
    DxPageHeaderLogoutBarDirective,
    DxPageHeaderNavBarDirective,
    DxPageHeaderToolBtnDirective,
    DxPageHeaderUserBarDirective,
    DxPageHeaderHelpBarDirective,
    DxPageHeaderSettingsBarDirective,
    DxPageHeaderNotificationBarDirective,
    DxErrorPageHeaderDirective,
    DxSplittedAreaComponent,
    DxSplittedAreaItemDirective
  ],
  imports: [
   CommonModule,
   AngularSplitModule.forRoot()
  ],
  providers: [],
  bootstrap: []
})
export class DxPageMarkupModule { }
